// extracted by mini-css-extract-plugin
export var body = "_mb-8";
export var button = "_mb-0";
export var closeButton = "_mb-5";
export var content = "_mb-3";
export var empty = "_mb-f";
export var grid = "_mb-c";
export var header = "_mb-4";
export var icon = "_mb-1";
export var option = "_mb-d";
export var optionSelected = "_mb-e";
export var overlay = "_mb-2";
export var searchIcon = "_mb-a";
export var searchInput = "_mb-b";
export var searchWrapper = "_mb-9";
export var title = "_mb-6";
export var visuallyHidden = "_mb-7";